<template lang="pug">
  .course-list-filter-block
    v-expand-transition
      .mb-7(v-if="activeFilters.length")
        p.caption Установленные фильтры:
        v-chip.mr-3(
          v-for="(filter, idx) in activeFilters"
          :key="idx"
          color="secondary"
          :close="$user.data.is_local ? true :  filter.key !== 'search[region]'"
          small
          clearable
          @click:close="removeActiveFilter(filter.key)"
        )
          span(v-if="filter.label").mr-1 {{ filter.label }} -
          span {{ filter.valueHumanized }}

    .duration-filter
      .d-flex.fill-width.align-center
        v-text-field.flex-grow-1(
          :value="filters['search[name]']"
          placeholder="Поиск курсов"
          :loading="loading"
          outlined
          clearable
          hide-details
          class="search-field"
          @keyup.enter="emitFilters"
          @input="filters['search[name]'] = $event"
        )
        v-slide-y-reverse-transition
          v-btn.mr-1(
            color="primary"
            depressed
            rounded
            :icon="$vuetify.breakpoint.xsOnly"
            @click="emitFilters"
          )
            v-icon mdi-magnify
            span.hidden-xs-only Поиск
        v-btn(@click="drawer = true" class="my-2" icon)
          v-icon mdi-tune

    v-navigation-drawer(
      v-model="drawer" temporary :width="isMobile ? '100%' : '600'" right fixed
    )
      v-card(flat).fill-height.overflow-auto
        v-card-text
          v-btn(text color="primary" small @click="drawer = false;")
            v-icon(left) mdi-arrow-left
            span Назад
          .d-flex.align-center
            v-card-title.black--text.text-h5.px-0: strong Фильтры
            v-btn(
              @click="clearFilters" small depressed rounded text
            ).ml-auto Сбросить
          .px-2.pt-6
            v-row
              v-col(v-if="!($user.data.is_local && !isTeacher)" cols=12)
                v-select(
                  @keyup.enter="emitFilters"
                  v-model="filters['search[type]']"
                  v-bind="typeAttrs"
                  label="Тип курса"
                  class="mr-2"
                  hide-details
                  clearable
                  solo
                  :outlined="$vuetify.theme.dark"
                  multiple
                  return-object
                )
              v-col(v-if="!$user.data.is_local && !isTeacher || $user.isOrganization" cols=12)
                v-select(
                  v-model="filters['search[direction]']"
                  :items="directions"
                  item-text="name"
                  hide-details
                  item-value="id"
                  :loading="directionsLoading"
                  label="Направленность"
                  clearable
                  solo
                  return-object
                  :outlined="$vuetify.theme.dark"
                  @keyup.enter="emitFilters"
                  @click:clear="removeActiveFilter('search[direction]')"
                )
              v-col(cols=12 v-if="!$user.data.is_local && !isTeacher || $user.isOrganization")
                v-select(
                  v-model="filters['search[activity]']"
                  :items="activities"
                  item-text="name"
                  hide-details
                  item-value="id"
                  :disabled="!filters['search[direction]']"
                  :loading="activitiesLoading"
                  label="Вид деятельности"
                  clearable
                  solo
                  return-object
                  :outlined="$vuetify.theme.dark"
                  @keyup.enter="emitFilters"
                )
              v-col(cols=12 v-if="$user.data.is_local && !isTeacher")
                server-data(
                  :method="$api.dir.regions"
                  search-field-name="search[name]"
                  v-slot="{ selectProps, search, loadMoreItems }"
                )
                  v-autocomplete-more(
                    v-model="filters['search[region]']"
                    v-bind="selectProps"
                    :items="selectProps.items.length ? selectProps.items : [initial.region]"
                    item-value="code"
                    label="Регион"
                    clearable
                    hide-details
                    solo
                    :outlined="$vuetify.theme.dark"
                    return-object
                    @update:search-input="search"
                    @load-more-items="loadMoreItems"
                    @keyup.enter="emitFilters"
                  )
              v-col(cols=12 v-if="$user.data.is_local")
                server-data(
                  :method="$api.dir.municipalities"
                  search-field-name="search[name]"
                  :query=`{
                    'search[region]': filters['search[region]'] && filters['search[region]'].id
                  }`
                  v-slot="{ selectProps, search, loadMoreItems }"
                )
                  v-autocomplete-more(
                    v-model="filters['search[municipality]']"
                    label="Муниципалитет"
                    v-bind="selectProps"
                    :items="selectProps.items.length ? selectProps.items : [initial.municipality]"
                    :disabled="isMunicipalityDisabled"
                    clearable
                    hide-details
                    solo
                    :outlined="$vuetify.theme.dark"
                    return-object
                    @keyup.enter="emitFilters"
                    @update:search-input="search"
                    @load-more-items="loadMoreItems"
                  )
              v-col(cols=12)
                server-data(
                  :method="$api.dir.organizations"
                  search-field-name="search[short_name]"
                  v-slot="{ selectProps, search, loadMoreItems }"
                )
                  v-autocomplete-more(
                    v-model="filters['search[organization]']"
                    v-bind="selectProps"
                    label="Организация"
                    item-text="short_name"
                    hide-details
                    clearable
                    solo
                    return-object
                    :outlined="$vuetify.theme.dark"
                    @keyup.enter="emitFilters"
                    @update:search-input="search"
                    @load-more-items="loadMoreItems"
                  )
              v-col(cols=12)
                v-text-field.mb-4(
                  @keyup.enter="emitFilters"
                  v-model="filters['search[age_min]']"
                  label="Минимальный возраст"
                  hide-details
                  clearable
                  solo
                  :outlined="$vuetify.theme.dark"
                )
              v-col(cols=12)
                .duration-filter.pa-4
                  v-range-slider(
                    v-model="duration"
                    class="align-center"
                    :max="maxDuration"
                    min="0"
                    thumb-label="always"
                    hide-details
                    :outlined="$vuetify.theme.dark"
                  )
                    template(v-slot:prepend)
                      v-text-field(
                        @keyup.enter="emitFilters"
                        :value="duration[0]"
                        class="mt-0 pt-0"
                        hide-details
                        single-line
                        type="number"
                        style="width: 60px"
                        @input="$set(duration, 0, $event)"
                      )
                    template(v-slot:append)
                      v-text-field(
                        @keyup.enter="emitFilters"
                        :value="duration[1]"
                        class="mt-0 pt-0"
                        hide-details
                        single-line
                        type="number"
                        style="width: 60px"
                        @input="$set(duration, 1, $event)"
                      )
                  v-subheader(class="pl-0 text-center justify-center") Количество учебных часов
          v-btn(
            color="success"
            rounded depressed block large
            @click="emitFilters(); setSearchLocation(); drawer = false"
          )
            v-icon(left) mdi-magnify
            | Найти
</template>

<script>
import { mapGetters } from 'vuex';

import SystemService from '@/services/API/SystemService';
import CourseService from '@/services/API/CourseService';
import DirectoryService from '@/services/API/DirectoryService';

const FILTER_LABELS = {
  'search[type]': 'Тип',
  'search[name]': 'Поиск',
  'search[code]': 'Код',
  'search[direction]': 'Направленность',
  'search[level]': 'Уровень',
  'search[age_min]': 'Минимальный возраст',
  'search[teacher]': 'Преподаватель',
};

const FILTER_HUMANIZER = {
  'search[organization]': (val) => val.short_name,
  'search[type]': (val) => val.text,
  'search[direction]': (val) => val.name,
  'search[activity]': (val) => val.name,
  'search[level]': (val) => val.title,
  'search[teacher]': (val) => val.name,
  'search[region]': (val) => val.name,
  'search[municipality]': (val) => val.name,
  'search[duration]': (val) => {
    const [start, end] = val.split(',');
    return `от ${start} до ${end} часов`;
  },
};

const FILTER_QUERY_SERIALIZER = {
  'search[organization]': (val) => val.id,
  'search[type]': (val) => val.value,
  'search[direction]': (val) => val.id,
  'search[activity]': (val) => val.id,
  'search[level]': (val) => val.value,
  'search[teacher]': (val) => val.id,
  'search[region]': (val) => val.code,
  'search[municipality]': (val) => val.id,
};

const FILTER_QUERY_TO_INTERNAL_VALUE = {
  'search[region]': (id) => DirectoryService.regionShow(id).then(({ data }) => data.data),
  'search[municipality]': (id) => DirectoryService.municipalityShow(id).then(({ data }) => data.data),
  'search[organization]': (id) => DirectoryService.organizationShow(id).then(({ data }) => data.data),
  'search[activity]': (id) => DirectoryService.programActivity(id).then(({ data }) => data.data),
  'search[direction]': (id) => DirectoryService.programDirectionShow(id).then(({ data }) => data.data),
};

export default {
  name: 'CourseListFilterBlock',
  props: {
    loading: { type: Boolean, default: false },
    noMountedEmit: { type: Boolean, default: false },
    initial: {
      type: Object,
      default: () => ({
        region: {},
        municipality: {},
      }),
    },
  },
  data() {
    return {
      drawer: false,
      directions: [],
      activities: [],
      maxDuration: 0,
      directionsLoading: false,
      activitiesLoading: false,
      duration: [0, 0], // Диапазон длительности курса, напр. [0, 200]
      regionId: null,
      filters: {
        'search[type]': null,
        'search[name]': null,
        'search[code]': null,
        'search[direction]': null,
        'search[activity]': null,
        'search[level]': null,
        'search[age_min]': null,
        'search[teacher]': null,
        'search[duration]': null,
        'search[region]': null,
        'search[municipality]': null,
        'search[organization]': null,
      },
    };
  },
  computed: {
    ...mapGetters(['courseResources']),
    isTeacher() {
      const { $user } = this;
      return $user.isTeacher && !$user.studentMode;
    },
    isMobile() {
      return !this.$vuetify.breakpoint.smAndUp;
    },
    typeAttrs() {
      const data = this.$conf.constantListProps('COURSE_TYPES');
      const {
        general,
        qualification,
        professional,
        personal,
      } = this.$conf.COURSE_TYPES;
      const filtered = {
        [this.$conf.ROLES.organization.value]: [general, qualification, professional, personal],
        [this.$conf.ROLES.teacher.value]: this.$user.data.is_local
          ? [qualification, professional, personal] : [qualification, professional, personal],
        [this.$conf.ROLES.student.value]: this.$user.data.is_local
          ? [qualification, professional, personal] : [general],
        [this.$conf.ROLES.listener.value]: this.$user.data.is_local
          ? [qualification, professional, personal] : [qualification],
      };
      return {
        ...data,
        items: data.items.filter(
          (el) => filtered[this.$user.data.role].includes(el.value),
        ),
        // .filter((el) => (this.$user.data.is_local ? [2, 3, 4].includes(el.value) : true)),
      };
    },
    isMunicipalityDisabled() {
      return !this.region;
    },
    search() {
      return this.filters['search[name]'];
    },
    region() {
      return this.filters['search[region]'];
    },
    direction() {
      return this.filters['search[direction]'];
    },
    activeFilters() {
      const getFilterObject = (key, value) => {
        const valueHumanized = (FILTER_HUMANIZER[key]
            && FILTER_HUMANIZER[key](value)) || value;

        const valueQuery = (FILTER_QUERY_SERIALIZER[key]
            && FILTER_QUERY_SERIALIZER[key](value)) || value;
        return {
          label: FILTER_LABELS[key],
          key,
          value,
          valueHumanized,
          valueQuery,
        };
      };
      return Object.entries(this.filters)
        .reduce((acc, [key, value]) => {
          if (value) {
            if (Array.isArray(value)) {
              value.forEach((el) => acc.push(getFilterObject(key, el)));
            } else acc.push(getFilterObject(key, value));
          }
          return acc;
        }, []);
    },
  },
  watch: {
    duration(val) {
      this.filters['search[duration]'] = val.join(',');
    },

    drawer(val) {
      if (val) this.init();
    },
    search(val) {
      this.$emit('search', val);
    },
    region(val) {
      if (!val) this.filters['search[municipality]'] = null;
    },
    direction(val) {
      return val && this.loadActivities();
    },
  },
  mounted() {
    if (this.$user.isAuthenticated && !this.$user.data.is_local && this.$user.isStudent) {
      if (this.initial.region.id) {
        this.filters['search[region]'] = this.initial.region;
      }
    }

    this.setupQuery();
    if (!this.noMountedEmit) this.emitFilters();
  },
  methods: {
    loadDirections() {
      if (this.directions.length) return;
      this.directionsLoading = true;
      this.$rHandler(
        SystemService.getDirections(),
        (r) => {
          this.directions = r.data.data;
          this.directionsLoading = false;
        },
      );
    },
    loadActivities() {
      const params = {
        'search[direction_id]': this.filters['search[direction]']?.id,
        'per-page': 200,
      };
      this.activitiesLoading = true;
      this.$rHandler(
        SystemService.getActivities(params),
        (r) => {
          this.activities = r.data.data;
          this.activities.unshift({ name: 'Все', id: null });
          this.activitiesLoading = false;
        },
      );
    },
    getMaxCourseDuration() {
      if (this.maxDuration) return;
      this.$rHandler(
        CourseService.getMaxCourseDuration(),
        (r) => {
          this.maxDuration = r.data.data;
        },
      );
    },
    /**
     * Вызывается при поиске курсов если заполнены фильтры региона и муниципалитета,
     * для записи их в localStorage для дальнейшего использования в фильтрах
     */
    setSearchLocation() {
      if (this.$user.isAuthenticated && this.filters['search[region]'] && this.filters['search[municipality]']) {
        const searchLocation = {
          region: this.filters['search[region]'],
          municipality: this.filters['search[municipality]'],
        };

        localStorage.setItem('CoursesSearchLocation', JSON.stringify(searchLocation));
      }
    },
    removeActiveFilter(key) {
      this.filters[key] = null;
      if (key === 'search[region]') { this.filters['search[municipality]'] = null; }
      if (key === 'search[direction]') { this.filters['search[activity]'] = null; }
      this.emitFilters();
    },
    setupQuery() {
      const query = { ...this.$route.query };
      Object.entries(query).forEach(([key, value]) => {
        const toInternalFunc = FILTER_QUERY_TO_INTERNAL_VALUE[key];

        if (toInternalFunc) toInternalFunc(value).then((val) => { this.filters[key] = val; });
        this.filters[key] = value;
      });
    },
    emitFilters() {
      this.$emit(
        'filters:update',
        this.activeFilters.reduce((acc, i) => ({ ...acc, [i.key]: i.valueQuery }), {}),
      );
    },
    init() {
      this.getMaxCourseDuration();
      this.loadDirections();
    },
    clearFilters() {
      this.filters = {
        'search[type]': null,
        'search[name]': null,
        'search[code]': null,
        'search[direction]': null,
        'search[activity]': null,
        'search[level]': null,
        'search[age_min]': null,
        'search[teacher]': null,
        'search[duration]': null,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
  .v-expansion-panels {
    position: sticky;
    top: 70px;
    box-shadow: 0 8px 24px -19px rgba(0, 0, 0, 0.8);
    border: 1px solid #f5f5f5;
    background-color: #fff;
    border-radius: 8px;

    &.theme--dark {
      background-color: #1e1e1e;
      border: 1px solid #222;
    }
  }

  .duration-filter {
    border-radius: 4px;
    margin-bottom: 30px;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
                0 2px 2px 0px rgba(0, 0, 0, 0.14),
                0 1px 5px 0px rgba(0, 0, 0, 0.12);

    &--dark {
      border: 1px solid #535353;
    }

  }

</style>
<style lang="scss">
  .search-field {
    border: none !important;

    fieldset {
      border: none !important;
    }
  }
</style>
